




export default {
  props: ['type'],
};
